import http from '@utils/http'

/*
* 查询直播投放用途的券信息
**/
export function queryStreamCouponInfo(data): Promise<any> {
    return http.post('/podpage/queryStreamCouponInfo', data || {})
}
/*
* 校验短信验证码
**/
export function verifyMsgCode(data): Promise<any> {
    return http.post('/podpage/verifyMsgCode', data || {})
}
/*
* 短信验证码
**/
export function sendMsg(data): Promise<any> {
    return http.post('/podpage/sendMsg', data || {})
}
/*
* 领取直播投放的优惠券兑换码
**/
export function receiveCouponCode(data): Promise<any> {
    return http.post('/podpage/receiveCouponCode', data || {})
}
